var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import CheckoutContainer from "../../OnBoarding-V2/Checkout01/CheckoutContainer";
import React, { useEffect, useState } from 'react';
import { fetchUserDetails } from "../../helpers";
import { publishRedirect } from "../../OnBoarding-V2/Events/utils.events";
import { getPlanIdFromQueryParams } from "../../OnBoarding-V2/Viewplans02/helper";
import UpgradeWrapper from "../../OnBoarding-V2/utils/UpgradeWrapper";
import { checkUserServiceWithMonetisation } from "./helper";
import { checkIfTveLoggedIn } from "../../OnBoarding-V2/LoginV2/Helpers/helper";
import { getStorageItem, setStorageItem } from "../../helpers/storageManager";
export var CheckoutModuleContainer = function (props) {
    var _a;
    var _b = __read(useState(false), 2), isUpgrade = _b[0], setIsUpgrade = _b[1];
    var metadataMap = (_a = props === null || props === void 0 ? void 0 : props.moduleData) === null || _a === void 0 ? void 0 : _a.metadataMap;
    function isUserAvailable() {
        return __awaiter(this, void 0, void 0, function () {
            var _a, isSubscribed, user, isTveLoggedIn, queryString, urlParams, authToken, userEmail, queryPlanId, redirected, userPlanId, isCheckout;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, fetchUserDetails()];
                    case 1:
                        _a = _f.sent(), isSubscribed = _a.isSubscribed, user = _a.user;
                        isTveLoggedIn = checkIfTveLoggedIn(user) ? true : false;
                        queryString = window.location.search;
                        urlParams = new URLSearchParams(queryString);
                        authToken = urlParams.get("auth");
                        userEmail = urlParams.get("email");
                        queryPlanId = getPlanIdFromQueryParams((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.href);
                        // after payment needs to reload the same page for showdetail and video detail.
                        if ((props === null || props === void 0 ? void 0 : props.isSeriesPage) || (props === null || props === void 0 ? void 0 : props.isVideoPage)) {
                            redirected = getStorageItem("isRedirected");
                            setStorageItem("isRedirected", __assign(__assign({}, redirected), { redirect: false, isDetailPage: true }));
                        }
                        if (queryPlanId && (queryPlanId === null || queryPlanId === void 0 ? void 0 : queryPlanId.toLowerCase()) !== "tve" && user && isSubscribed) {
                            userPlanId = (_d = (_c = user === null || user === void 0 ? void 0 : user.subscription) === null || _c === void 0 ? void 0 : _c.subscriptionInfo) === null || _d === void 0 ? void 0 : _d.planId;
                            if (queryPlanId !== userPlanId) {
                                return [2 /*return*/, setIsUpgrade(true)];
                            }
                            return [2 /*return*/, publishRedirect("/")];
                        }
                        if (!authToken && !userEmail) {
                            isCheckout = ((_e = props === null || props === void 0 ? void 0 : props.moduleData) === null || _e === void 0 ? void 0 : _e.moduleType) === "CheckoutModule";
                            checkUserServiceWithMonetisation({ user: user, isSubscribed: isSubscribed, isTveLoggedIn: isTveLoggedIn, isCheckout: isCheckout });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        isUserAvailable();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(CheckoutContainer, __assign({}, props, { isUpgrade: isUpgrade })),
        isUpgrade ? React.createElement(UpgradeWrapper, { metadataMap: metadataMap, isViewplans: false }) : React.createElement(React.Fragment, null)));
};
export default CheckoutModuleContainer;
